import { IUserData } from "api/auth";
import axios from "api/axios";
import axiosBase from "axios";
import { IHackathonResponse } from "api/hackathon";
import { IProject } from "api/project";

import { IPortfolioResponse, IRebakedPost, IUpdateThemeParams } from "./types";

export const updatePortfolioThemeRequest = async (
  params: IUpdateThemeParams
) => {
  return await axios({
    url: "/user/update_theme",
    method: "PUT",
    data: params,
  });
};

export const getPortfolioByUsernameRequest = async (
  username: string
): Promise<IPortfolioResponse> => {
  const { data } = await axios({
    url: `/user/portfolio/${username}`,
    method: "GET",
  });
  return data;
};

export const getPortfolioFollowerRequest = async (
  userId: string
): Promise<IUserData[]> => {
  const { data } = await axios({
    url: `/user/portfolio/flowers/${userId}`,
    method: "GET",
  });
  return data;
};

export const getPortfolioFollowingRequest = async (
  userId: string
): Promise<IUserData[]> => {
  const { data } = await axios({
    url: `/user/portfolio/${userId}/flowing`,
    method: "GET",
  });
  return data;
};

export const getPortfolioLikeRequest = async (
  userId: string
): Promise<IProject[]> => {
  const { data } = await axios({
    url: `/user/portfolio/${userId}/like`,
    method: "GET",
  });
  return data;
};

export const getPortfolioHackathonRequest = async (
  userId: string
): Promise<IHackathonResponse[]> => {
  const { data } = await axios({
    url: `/submission/list_hackathon_participant/${userId}`,
    method: "GET",
  });
  return data;
};

// export const getMediumRebakedRequest = async (): Promise<IRebakedPost[]> => {
//   const { data } = await axios({
//     url: `/medium`,
//     method: "GET",
//   });

//   return data.items;
//   // return fetch(
//   //   "https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/rebakedinc"
//   // )
//   //   .then((res) => res.json())
//   //   .then((data) => {
//   //     const res = data.items;
//   //     return res;
//   //   });
// };

export const getRebakedBlogPostsRequest = async (): Promise<IRebakedPost[]> => {
  const { data } = await axios({
    url: `/blog`,
    method: "GET",
  });
  return data;
};
